import { CommonModule, NgIf } from '@angular/common'
import { Component, inject, OnDestroy, OnInit } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import { Store } from '@ngrx/store'
import { Observable, Subject, takeUntil } from 'rxjs'
import { ActivatedRoute } from '@angular/router'
import { PayOutMode } from '../../../../store/payout-agreement/payout-agreement.state'
import {
  selectRevisedStatutoryCompliances,
  selectStatutoryCompliances
} from '../../../../store/payout-agreement/payout-agreement.selectors'
import {
  payoutAgreementActions,
  payoutRevisionActions
} from '../../../../store/payout-agreement/payout-agreement.actions'
import { StatutoryCompliances } from '../../../../store/employee-salary/employee-salary.state'

@Component({
  selector: 'app-statutory-compliances',
  imports: [NgIf, FormsModule, CommonModule, ReactiveFormsModule],
  templateUrl: './statutory-compliances.component.html',
  styleUrl: './statutory-compliances.component.scss'
})
export class StatutoryCompliancesComponent implements OnInit, OnDestroy {
  private store = inject(Store)
  private route = inject(ActivatedRoute)
  private destroyed$ = new Subject<void>()
  private statutoryCompliances$!: Observable<StatutoryCompliances | null>
  private fb = inject(FormBuilder)
  public currentMode!: PayOutMode
  public payOutMode = PayOutMode
  form!: FormGroup
  constructor() {
    this.initializeForm()
  }

  ngOnInit(): void {
    this.currentMode = this.route.snapshot.data['mode'] as PayOutMode

    switch (this.currentMode) {
      case PayOutMode.CREATE:
        this.statutoryCompliances$ = this.store.select(selectStatutoryCompliances)
        break
      case PayOutMode.REVISE:
      case PayOutMode.UPDATE:
        this.statutoryCompliances$ = this.store.select(selectRevisedStatutoryCompliances)
        break
      default:
        throw new Error(`Unknown payout mode: ${this.currentMode}`)
    }

    this.statutoryCompliances$.pipe(takeUntil(this.destroyed$)).subscribe(complianceData => {
      if (complianceData) {
        this.form.patchValue(complianceData)
      }
    })
  }

  ngOnDestroy() {
    switch (this.currentMode) {
      case PayOutMode.CREATE:
        this.store.dispatch(
          payoutAgreementActions.addStatutoryCompliances({ statutoryCompliances: this.form.value })
        )
        break
      case PayOutMode.REVISE:
      case PayOutMode.UPDATE:
        this.store.dispatch(
          payoutRevisionActions.updateStatutoryCompliances({
            statutoryCompliances: this.form.value
          })
        )
        break
      default:
        throw new Error(`Unknown payout mode: ${this.currentMode}`)
    }

    this.destroyed$.next()
    this.destroyed$.complete()
  }

  initializeForm() {
    this.form = this.fb.group({
      pf: [false, Validators.required],
      eps: [false, Validators.required],
      employerCapping: [false, Validators.required],
      esi: [false, Validators.required],
      lwf: [false, Validators.required],
      pt: [false, Validators.required]
    })
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
    }
    return null // No error
  }
}
